<template>
    <div v-if="hasErrors" class="flags mt-xs text--orange">
        <svg><use xlink:href="#alert" /></svg>
        <div>
            <p v-if="maxWatts" class="small semi">This system is in excess of 100kW and is no longer eligible for STCs. The system may be eligible for LGCs.</p>
        </div>
    </div>
</template>

<script>
import { calculateSystemSize } from '@/../utils';

export default {
    props: {
        configuration: {
            type: Array,
            default: () => []
        },
    },

    computed: {
        hasErrors() {
            return this.maxWatts
        },

        configurationSize() {
            return calculateSystemSize(this.configuration);
        },

        maxWatts() {
            return this.configurationSize > 100000;
        },
    }
};
</script>

<style lang="scss" scoped>
    .flags {
        .small {
            padding-bottom: 10px;
        }
    }
</style>
